// extracted by mini-css-extract-plugin
export default {"assetsInformation":"informationSection_assetsInformation__fcN2q","assetsText":"informationSection_assetsText__wc-+L"};